const yup = require("yup");

const create = yup.object({
  name: yup.string().required("Name is required"),
  description: yup.string().min(2, "Minimum of 2 characters expected").required("Description a required fields"),
  status: yup.boolean().required("Status is a required fields"),
});

const score = yup.object({
  from: yup.number().required("From value is required"),
  to: yup.number().required("To value is required"),
  point: yup.number().required("Point value is required"),
  grade: yup.string().required("Grade is a required fields"),
});

const step = yup.object({
  level: yup.string().required("Level value is required"),
  semester: yup.string().required("Semester value is required"),
  step: yup.number().required("Step is a required fields"),
});

module.exports = {
  create,
  score,step
};
